function onScroll() {
  document.addEventListener('scroll', () => {
    document.querySelector('.arrow-up').hidden = pageYOffset <= 130;
  })
}
